// extracted by mini-css-extract-plugin
export default {"submitSaveAndSend":"XMKmduXeWgazzeHaHehjQ button success","submitSaveAndSendIcon":"_7k7hlDattHtU5f2euXgZNt"};